<template>
  <div ref="chart" style="width: 100%; height: 400px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'DataChart',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null,
      resizeHandler: null
    };
  },
  mounted() {
    this.initChart();
    this.resizeHandler = () => {
      if (this.chart) {
        this.chart.resize();
      }
    };
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeUnmount() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  watch: {
    options: {
      deep: true,
      handler(newOptions) {
        if (this.chart && newOptions) {
          this.chart.setOption(newOptions, true);
        } else if (!this.chart && newOptions) {
          this.initChart();
        }
      }
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chart || !this.options) {
        return;
      }
      if (this.chart) {
        this.chart.dispose();
      }
      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(this.options);
    }
  }
};
</script>

<style scoped>
/* 可根据需要添加样式 */
</style>
